import { NgModule } from '@angular/core';
import { MatSelectInfiniteScrollDirective } from './mat-select-infinite-scroll.directive';

@NgModule({
  declarations: [MatSelectInfiniteScrollDirective],
  exports: [MatSelectInfiniteScrollDirective],
})
export class MatSelectInfiniteScrollModule {}
